import {
  CARS,
  CRUISES,
  FLIGHTS,
  VACATION_RENTALS,
  GUESTBOOK,
  HOTELS,
  INTL_PATH_PACKAGES,
  US_PATH_PACKAGES,
  PACKAGES,
} from '../constants/lineOfBusinessConstants';

const getLineOfBusinessFromPath = (isPackagesDisabledByFF, path = '') => {
  if (path) {
    const pathSegments = path.split('/')
      .filter((segment) => segment !== '');
    const lastPathSegment = pathSegments[pathSegments.length - 1];
    switch (lastPathSegment) {
      case FLIGHTS:
        return FLIGHTS;
      case HOTELS:
        return HOTELS;
      case VACATION_RENTALS:
        return VACATION_RENTALS;
      case GUESTBOOK:
        return GUESTBOOK;
      case INTL_PATH_PACKAGES:
        return isPackagesDisabledByFF ? HOTELS : PACKAGES;
      case US_PATH_PACKAGES:
        return isPackagesDisabledByFF ? HOTELS : PACKAGES;
      case CARS:
        return CARS;
      case CRUISES:
        return CRUISES;
      default:
        break;
    }
  }
  return HOTELS;
};

export default getLineOfBusinessFromPath;
